import { Text } from "@mantine/core"

import { Currency } from "@costory/types/prisma-client"

import { formatNumber, NumberType } from "@costory/shared/utils/format"

type Props = {
  value: number
  numberType?: NumberType
  disableColor?: boolean
  currency: Currency
}

export const NumberCell = ({
  value,
  numberType = "currency",
  disableColor = false,
  currency = "USD",
}: Props) => (
  <Text
    size="sm"
    c={
      !disableColor && numberType === "percent"
        ? value < 0
          ? "green.6"
          : "red.6"
        : "inherit"
    }
  >
    {formatNumber({ value, numberType, currency, extraDigits: 2 })}
  </Text>
)
